import {memo} from "react";
import {ListItem, ListItemPrefix, ListItemSuffix} from "@material-tailwind/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {Link} from "react-router-dom";

export interface MenuItemProps {
    name: string,
    leftIcon?: JSX.Element,
    rightIcon?: JSX.Element,
    link?: string,
    onClick?: () => void
}

const MenuItem = ({name, link, leftIcon, rightIcon, onClick}: MenuItemProps) => {
    const right = rightIcon ? <ListItemSuffix>{rightIcon}</ListItemSuffix> : null;
    const onLocalClick = () => {
        if (onClick) {
            onClick();
        }
    }

    if (link){
        return <Link to={link}>
            <ListItem ripple={false} className="sidebar-accordion-item">
                <ListItemPrefix>
                    {leftIcon ? leftIcon : <FontAwesomeIcon className="h-3 w-5" icon={solid("chevron-right")}/>}
                </ListItemPrefix>
                <span>{name}</span>
                {right}
            </ListItem>
        </Link>
    }

    return (
        <ListItem ripple={false} className="sidebar-accordion-item" onClick={onLocalClick}>
            <ListItemPrefix>
                {leftIcon ? leftIcon : <FontAwesomeIcon className="h-3 w-5" icon={solid("chevron-right")}/>}
            </ListItemPrefix>
            <span>{name}</span>
            {right}
        </ListItem>
    );
}

export default memo(MenuItem);
